.appLinks {
  display: none;
}
@media (max-width: 768px) {
  .appLinks {
    margin-block-start: var(--cxy-spacing-3);
    display: flex;
    gap: var(--cxy-spacing-2);
  }
  .appLinks > a,
  .appLinks img {
    height: 40px;
  }
}
